import { FunctionComponent } from "react";
import POLineItemCardWeb from "./POLineItemCardWeb";
import POLineItemCardMobile from "./POLineItemCardMobile";
import { POLineItemCardProps } from "./types";

/**
 * Unified PO line-item card used across Create / Update / Approve / Details
 * (regular + Job Work). Renders both shells and shows one per breakpoint via
 * CSS (the app's md table-vs-card convention) — reliable in DevTools device
 * emulation. Both share {@link usePOLineItem}, so behavior is identical.
 */
const POLineItemCard: FunctionComponent<POLineItemCardProps> = (props) => (
  <>
    <div className="hidden md:block">
      <POLineItemCardWeb {...props} />
    </div>
    <div className="md:hidden">
      <POLineItemCardMobile {...props} />
    </div>
  </>
);

export default POLineItemCard;
